export default function ShopIcon() {
  return (
    <svg width="18" height="18" fill="none" viewBox="0 0 18 18">
      <path
        fill="#9E9E9E"
        fillRule="evenodd"
        d="M6.554 9.286a3.2 3.2 0 01-2.592 1.32 3.19 3.19 0 01-2.22-.893v3.77A3.718 3.718 0 005.46 17.2h7.104a3.718 3.718 0 003.718-3.717V9.69a3.19 3.19 0 01-2.244.917 3.2 3.2 0 01-2.592-1.32A2.922 2.922 0 019 10.606a2.922 2.922 0 01-2.446-1.32z"
        clipRule="evenodd"
      />
      <path
        fill="#9E9E9E"
        fillRule="evenodd"
        d="M.972 3.953A3.453 3.453 0 014.414.792h2.752V6.61A3.204 3.204 0 11.77 6.34l.202-2.387zM10.834.792h2.752a3.453 3.453 0 013.441 3.161l.203 2.386a3.204 3.204 0 11-6.396.271V.792z"
        clipRule="evenodd"
      />
      <path
        fill="#9E9E9E"
        fillRule="evenodd"
        d="M6.075.792h5.85v6.097a2.925 2.925 0 11-5.85 0V.792z"
        clipRule="evenodd"
      />
    </svg>
  );
}
